// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3pfwa","colMin":"styles_colMin__3C5o0"};